<ng-container *ngIf="policyModalVisible$ | async as visibleDrawer">
  <nz-drawer
    [nzClosable]="false"
    [nzMaskClosable]="false"
    [nzKeyboard]="false"
    [nzVisible]="visibleDrawer"
    [nzHeight]="420"
    nzWrapClassName="pm-cookies-allowed-modal"
    nzPlacement="bottom">
  <ng-container *nzDrawerContent>

    <h2 class="text-[24px] font-medium mb-[15px]">
        {{ 'cookiesAllowedBlock.modalPolicy.title' | translate }}
    </h2>
    <p class="text-[15px] font-light text-left">
        {{ 'cookiesAllowedBlock.modalPolicy.messages' | translate }}
    </p>

    <button
         class="w-full mt-auto"
         pm-button
         [pmType]="'secondary'"
         (click)="setStatusCookiesPolicy(false)"
         type="button">{{ 'cookiesAllowedBlock.modalPolicy.buttonSwitchEssential' | translate }}
    </button>
    <button
          class="mt-[15px] w-full"
          pm-button
          (click)="setStatusCookiesPolicy(true)"
          type="button">{{ 'cookiesAllowedBlock.modalPolicy.buttonSwitchAll' | translate }}
    </button>

  </ng-container>
 </nz-drawer>
</ng-container>
